import { Button as WCButton } from '@acorns/web-components'
import styled from 'styled-components'

import { style } from 'theme'

const Button = styled(WCButton)<{ wider?: boolean }>`
  margin: 0 auto;
  min-width: 220px;

  @media (min-width: ${style((theme) => theme.breakpoints.sm + 1)}px) {
    min-width: ${(props) => (props.wider ? 340 : 220)}px;
  }

  @media (max-width: ${style((theme) => theme.breakpoints.sm)}px) {
    min-width: 0;
    width: 100%;
    max-width: ${(props) => (props.wider ? 340 : 'unset')}px;
  }
`

export default Button
